<h2 mat-dialog-title>
  <mat-icon>pause_circle</mat-icon>
  You are about to inactivate this property
</h2>
<form [formGroup]="reactivateForm">
  <mat-dialog-content class="column">
    <mat-form-field class="row" appearance="outline">
      <mat-label>Started renting</mat-label>
      <input formControlName="startedRenting" [matDatepicker]="picker" matInput>
      <mat-hint>MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle [for]="picker" matIconSuffix></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <mat-form-field appearance="outline" class="row">
      <mat-label>Filing Frequency</mat-label>
      <mat-select formControlName="frequency" placeholder="Filing Frequency">
        <mat-option *ngFor="let freq of FrequencyLabelMap | keyvalue" [value]="freq.key">{{freq.value}}</mat-option>
      </mat-select>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button class="go-back" mat-button mat-dialog-close>GO BACK</button>
    <button [disabled]="reactivateForm.invalid" cdkFocusInitial
            mat-button class="continue" (click)="reactivate()">
      <mat-icon fontIcon="play_circle"></mat-icon>REACTIVATE PROPERTY</button>
  </mat-dialog-actions>
</form>

